import React from 'react';
import { Navigate } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';

/**
 * /pricing is a redirect to /#pricing (same content as landing).
 * Canonical + noindex prevent duplicate content: search engines should index only https://feedpanels.com/
 */
export const PricingRedirect = () => (
  <>
    <Helmet>
      <title>Pricing - FeedPanels</title>
      <meta name="description" content="View FeedPanels pricing plans and choose the right plan for your team. This page redirects to the pricing section on our homepage." />
      <link rel="canonical" href="https://feedpanels.com/" />
      <meta name="robots" content="noindex, follow" />
    </Helmet>
    <Navigate to="/#pricing" replace />
  </>
);
